export const backgroundColors = {
  bgPrimary: '#2C2C2C',
  bgPrimary_op10: 'rgba(44, 44, 44, 0.1)',
  bgPrimary_op80: 'rgba(44, 44, 44, 0.8)',
  bgSecondary: '#232323',
  bgSecondary_op20: 'rgba(35, 35, 35, 0.2)',
  bgSecondary_op40: 'rgba(35, 35, 35, 0.4)',
  bgSecondary_op80: 'rgba(35, 35, 35, 0.8)',
  bgTertiary: '#373737',
  bgTertiary_op10: 'rgba(55, 55, 55, 0.1)',
  bgTertiary_op20: 'rgba(55, 55, 55, 0.2)',
  bgTertiary_op50: 'rgba(55, 55, 55, 0.5)',
  bgTertiary_op80: 'rgba(55, 55, 55, 0.8)',
  bgBrand: '#7750ED',
  bgInverted: '#F7F6ED',
}

export const foregroundColors = {
  fgPrimary: '#F7F6ED',
  fgPrimary_op80: 'rgba(247, 246, 237, 0.8)',
  fgPrimary_op60: 'rgba(247, 246, 237, 0.6)',
  fgPrimary_op50: 'rgba(247, 246, 237, 0.5)',
  fgPrimary_op10: 'rgba(247, 246, 237, 0.1)',
  fgSecondary: 'rgba(247, 246, 237, 0.6)',
  fgSecondary2: 'rgba(166, 165, 159, 1)', // Same as $fgSecondary on $bgPrimary
  fgBrand: '#7750ED',
  fgInverted: '#2C2C2C',
  fgDarkGreen: '#1E2807',
}

export const borderColors = {
  borderPrimary: '#F7F6ED',
  borderSecondary: '#545452',
  borderSecondary_op20: 'rgba(247, 246, 237, 0.2)',
  borderSecondary_op40: 'rgba(246, 246, 237, 0.4)',
  borderBrand: '#7750ED',
  borderInverted: '#2C2C2C',
}

export const brandColors = {
  brandOlive: '#435F49',
  brandTeal: '#71A59B',
  brandPurple: '#7750ED',
  brandPurple_op80: 'rgba(119, 80, 237, 0.8)',
  brandBlue: '#C5D2FF',
  brandPink: '#FFBBE7',
  brandPink_op80: 'rgba(255, 187, 231, 0.8)',
  brandMustard: '#F8CD3A',
  brandMustard_op80: 'rgba(248, 205, 58, 0.8)',
  brandRust: '#C15230',
}

export const functionalColors = {
  fgError: '#FF8080',
  bgError: '#422A2A',
  fgInfo: '#4E8ADF',
  bgInfo: '#303946',
  fgSuccess: '#6EE7B7',
  bgSuccess: '#1a3329',
}

export const commonColors = {
  transparent: 'rgba(0, 0, 0, 0)',
  black: '#000000',
  white: '#FFFFFF',
  backdrop: 'rgba(0, 0, 0, 0.5)',
}
